import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';

const PRELOADER_MIN_MS = 1100;

export function Layout() {
  const { pathname } = useLocation();
  const bare = pathname === '/login';

  useEffect(() => {
    const node = document.getElementById('sa-preloader');
    if (!node) return;
    const started = performance.now();
    const min = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 200 : PRELOADER_MIN_MS;
    let closed = false;

    const finish = () => {
      if (closed) return;
      closed = true;
      const wait = Math.max(0, min - (performance.now() - started));
      window.setTimeout(() => {
        node.classList.add('is-leaving');
        window.setTimeout(() => node.remove(), 480);
      }, wait);
    };

    if (document.readyState === 'complete') finish();
    else window.addEventListener('load', finish, { once: true });
    const cap = window.setTimeout(finish, 2800);
    return () => window.clearTimeout(cap);
  }, []);

  return (
    <div>
      {bare ? null : <SiteHeader />}
      <Outlet />
    </div>
  );
}
